import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import NavbarS2 from '../../components/NavbarS2/NavbarS2';
import PageTitle from '../../components/pagetitle/PageTitle'
import AboutS2 from '../../components/about2/about2';
import FunFactS2 from '../../components/FunFactS2/FunFactS2';
import ServiceSection4 from '../../components/ServiceSection4/ServiceSection4';
import CtaSection from '../../components/CtaSection/CtaSection';
import DonateSection from '../../components/DonateSection/DonateSection';
import TeamSection from '../../components/TeamSection/TeamSection';
import ProjectSectionS2 from '../../components/ProjectSectionS2/ProjectSectionS2';
import Testimonial2 from '../../components/Testimonial2/Testimonial2';
import PartnerSectionS3 from '../../components/PartnerSectionS3/PartnerSectionS3';
import FooterS2 from '../../components/footerS2/FooterS2';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png'
import BlogSection from '../../components/BlogSection/BlogSection';
import bg from '../../images/gallery/SSK_0079.png'


import CtaSectionS3 from '../../components/CtaSectionS3/CtaSectionS3';
const AboutPage = () => {
    return (
        <Fragment>
            <NavbarS2 hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={'About Us'} pagesub={'About'} bg={bg} />
            <AboutS2 hclass={'about-section-s4 section-padding'} />
            <FunFactS2 hclass={'funfact-section-s2'} />
            <ServiceSection4 hclass={"service-section-s5 section-padding"} />
            <CtaSection hclass={'cta-section'} />
            <DonateSection />
            <TeamSection hclass={'volunteer-section section-padding'} />
            <ProjectSectionS2 hclass={'project-section-s2 section-padding'} />
            <Testimonial2 tClass={'testimonial-section-s2 section-padding'} />
            <PartnerSectionS3 />
            {/* <BlogSection tClass={'blog-section-s2'} /> */}
            <CtaSectionS3 />
            <FooterS2 />
            <Scrollbar />

        </Fragment>
    )
};
export default AboutPage;
